export default __webpack_public_path__ + "static/media/mobile.39837978.png";